export const textSimilarity = (str1, str2) => {
    // Simple implementation of text similarity
    // You might want to use a more sophisticated algorithm like Levenshtein distance
    if (!str1 || !str2) return 0;
    
    const s1 = str1.toLowerCase();
    const s2 = str2.toLowerCase();
    
    if (s1 === s2) return 1;
    if (s1.includes(s2) || s2.includes(s1)) return 0.8;
    
    // Simple character matching
    const chars1 = new Set(s1);
    const chars2 = new Set(s2);
    const intersection = new Set([...chars1].filter(x => chars2.has(x)));
    const union = new Set([...chars1, ...chars2]);
    
    return intersection.size / union.size;
}; 